namespace RioERP.Web.Enums {
    export enum PackingType {
        Envelop = 1,
        SmallBox = 2,
        BigBox = 3,
        Other = 4
    }
    Serenity.Decorators.registerEnumType(PackingType, 'RioERP.Web.Enums.PackingType');
}
